"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProductSpecialtyType = exports.NotifyMeError = exports.ProductImageSizesPortraitEnum = exports.ProductExcluded = exports.ProductLinkType = exports.ProductVideoModeTypes = exports.ProductTypes = void 0;
var ProductTypes;
(function (ProductTypes) {
    ProductTypes["PRODUCT"] = "PRODUCT";
    ProductTypes["E_VOUCHER"] = "E_VOUCHER";
    ProductTypes["GIFT_CARD"] = "GIFT_CARD";
    ProductTypes["CUSTOM_GIFT_CARD"] = "CUSTOM_GIFT_CARD";
    ProductTypes["PAPER_VOUCHER"] = "PAPER_VOUCHER";
    ProductTypes["CUSTOM_PAPER_VOUCHER"] = "CUSTOM_PAPER_VOUCHER";
})(ProductTypes || (exports.ProductTypes = ProductTypes = {}));
var ProductVideoModeTypes;
(function (ProductVideoModeTypes) {
    ProductVideoModeTypes["INSPIRATIONAL"] = "INSPIRATIONAL";
    ProductVideoModeTypes["CARROUSEL"] = "CARROUSEL";
})(ProductVideoModeTypes || (exports.ProductVideoModeTypes = ProductVideoModeTypes = {}));
var ProductLinkType;
(function (ProductLinkType) {
    ProductLinkType["ALT"] = "ALT";
    ProductLinkType["STL"] = "STL";
})(ProductLinkType || (exports.ProductLinkType = ProductLinkType = {}));
var ProductExcluded;
(function (ProductExcluded) {
    ProductExcluded["CC_EXCLUDED"] = "CC Excluded";
    ProductExcluded["CC_NOT_EXCLUDED"] = "CC Not Excluded";
    ProductExcluded["HD_EXCLUDED"] = "HD Excluded";
    ProductExcluded["HD_NOT_EXCLUDED"] = "HD Not Excluded";
    ProductExcluded["SS_EXCLUDED"] = "SS Excluded";
    ProductExcluded["SS_NOT_EXCLUDED"] = "SS Not Excluded";
})(ProductExcluded || (exports.ProductExcluded = ProductExcluded = {}));
var ProductImageSizesPortraitEnum;
(function (ProductImageSizesPortraitEnum) {
    ProductImageSizesPortraitEnum["thumb"] = "65x98";
    ProductImageSizesPortraitEnum["bundles"] = "109x164";
    ProductImageSizesPortraitEnum["basket"] = "180x279";
    ProductImageSizesPortraitEnum["lister"] = "316x474";
    ProductImageSizesPortraitEnum["detail"] = "550x825";
    ProductImageSizesPortraitEnum["zoom"] = "989x1484";
})(ProductImageSizesPortraitEnum || (exports.ProductImageSizesPortraitEnum = ProductImageSizesPortraitEnum = {}));
var NotifyMeError;
(function (NotifyMeError) {
    NotifyMeError["SELECT_SIZE"] = "NOTIFY_ME_SELECT_SIZE";
})(NotifyMeError || (exports.NotifyMeError = NotifyMeError = {}));
var ProductSpecialtyType;
(function (ProductSpecialtyType) {
    ProductSpecialtyType["WINTERSPORT"] = "WINTERSPORT";
})(ProductSpecialtyType || (exports.ProductSpecialtyType = ProductSpecialtyType = {}));
//# sourceMappingURL=ProductEnums.js.map